import { Box, Center, Loader } from '@mantine/core';
import { DateValue } from '@mantine/dates';

import { useGetInstagramReport } from '../../api/getInstagramReport';
import { LABELS } from '../../constants';

import { InstagramAnalyticsTable } from './Table/AnalyticsTable';

type InstagramAnalyticsProps = {
  pageId: string;
  dates: [DateValue, DateValue];
  topic: string;
  geo: string;
  pageLink: string;
};

export const InstagramAnalyticsData = ({
  pageId,
  dates,
  topic,
  geo,
  pageLink,
}: InstagramAnalyticsProps) => {
  const [from, to] = dates;

  const dateFrom = from?.valueOf() || 0;
  const dateTo = to?.valueOf() || 0;

  const getInstagramReport = useGetInstagramReport({
    dateFrom,
    dateTo,
    topic,
    pageId,
    pageLink,
    geo,
  });

  if (!dateFrom || !dateTo) {
    return <Center>{LABELS.NO_FILTERS_SELECTION}</Center>;
  }

  if (getInstagramReport.error) {
    return <Center>{LABELS.DATA_LOAD_ERROR}</Center>;
  }

  if (getInstagramReport.isLoading) {
    return (
      <Center>
        <Loader m="xs" size="xl" />
      </Center>
    );
  }

  if (!getInstagramReport.data?.length) {
    return <Center>{LABELS.NO_FILTER_DATA}</Center>;
  }

  return (
    <Box style={{ overflow: 'auto' }}>
      <InstagramAnalyticsTable data={getInstagramReport.data} />
    </Box>
  );
};
